// material-ui
import { Link, Typography, Stack } from "@mui/material";

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const PageFooter = () => (
  <Stack direction="row" justifyContent="space-between">
    <Typography
      variant="subtitle2"
      component={Link}
      href="https://socialproapp.io"
      target="_blank"
      underline="hover"
    >
      socialproapp.io
    </Typography>
    <Typography
      variant="subtitle2"
      component={Link}
      href="https://socialproapp.io"
      target="_blank"
      underline="hover"
    >
      &copy; socialproapp.io
    </Typography>
  </Stack>
);

export default PageFooter;
